import { SVGProps } from 'react';

const Merge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16 6-4-4-4 4m4-4v10.3a4 4 0 0 1-1.172 2.872L4 22m16 0-5-5"
    />
  </svg>
);
export default Merge;
